import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyPurchaseOverviewPart = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/purchases/summary/part/list',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
